import { forwardRef, ChangeEvent, ClipboardEvent } from "react";
import { MaskInput } from "../mask-input";
import { DETAILS_TYPES } from "./constants";
import { getUnmaskedValue } from "./utils";
import { DetailsInputProps } from "./types";

export const DetailsInput = forwardRef<HTMLInputElement, DetailsInputProps>(
  (
    { type, onChange, onCopy, dataTestId = "details-input", ...props },
    forwardedRef
  ) => {
    const mask = DETAILS_TYPES[type];

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
      const { value } = event.target;
      const unmaskedValue = getUnmaskedValue(value);

      onChange?.(event, { value, unmaskedValue });
    };

    const handleCopy = (event: ClipboardEvent<HTMLInputElement>) => {
      const selectedValue = document.getSelection()?.toString();
      const unmaskedValue = getUnmaskedValue(selectedValue);

      if (unmaskedValue) {
        navigator.clipboard.writeText(unmaskedValue);
      }

      onCopy?.(event);
    };

    return (
      <MaskInput
        mask={mask}
        onChange={handleChange}
        onCopy={handleCopy}
        dataTestId={dataTestId}
        ref={forwardedRef}
        {...props}
      />
    );
  }
);
